function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "10.583mm",
    height: "10.583mm",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v15H0V7.5Z",
    style: {
      fill: "#1eb53a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,7.5h30v7.5H0v-7.5Z",
    style: {
      fill: "#0099b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.3h30v5.4H0v-5.4Z",
    style: {
      fill: "#ce1126"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,12.6h30v4.8H0v-4.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.2,
    cy: 9.9,
    r: 1.8,
    transform: "translate(-5.71 14.076) rotate(-89.862)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.8,
    cy: 9.9,
    r: 1.8,
    transform: "translate(-5.112 14.676) rotate(-89.862)",
    style: {
      fill: "#0099b5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8.16,10.98l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a1",
    "data-name": "a",
    d: "M8.16,10.98l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a2",
    "data-name": "a",
    d: "M8.502,11.229h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a3",
    "data-name": "a",
    d: "M8.502,11.229l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4",
    "data-name": "a",
    d: "M7.818,11.229l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a5",
    "data-name": "a",
    d: "M7.818,11.229h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a6",
    "data-name": "a",
    d: "M8.372,11.631l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a7",
    "data-name": "a",
    d: "M8.372,11.631l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a8",
    "data-name": "a",
    d: "M7.948,11.631l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a9",
    "data-name": "a",
    d: "M7.948,11.631l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a10",
    "data-name": "a",
    d: "M8.16,9.54l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a11",
    "data-name": "a",
    d: "M8.16,9.54l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a12",
    "data-name": "a",
    d: "M8.502,9.789h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a13",
    "data-name": "a",
    d: "M8.502,9.789l-.291.211-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a14",
    "data-name": "a",
    d: "M7.818,9.789l.291.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a15",
    "data-name": "a",
    d: "M7.818,9.789h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a16",
    "data-name": "a",
    d: "M8.372,10.191l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a17",
    "data-name": "a",
    d: "M8.372,10.191l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a18",
    "data-name": "a",
    d: "M7.948,10.191l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a19",
    "data-name": "a",
    d: "M7.948,10.191l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a20",
    "data-name": "a",
    d: "M8.16,8.1l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a21",
    "data-name": "a",
    d: "M8.16,8.1l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a22",
    "data-name": "a",
    d: "M8.502,8.349h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a23",
    "data-name": "a",
    d: "M8.502,8.349l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a24",
    "data-name": "a",
    d: "M7.818,8.349l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a25",
    "data-name": "a",
    d: "M7.818,8.349h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a26",
    "data-name": "a",
    d: "M8.372,8.751l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a27",
    "data-name": "a",
    d: "M8.372,8.751l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a28",
    "data-name": "a",
    d: "M7.948,8.751l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a29",
    "data-name": "a",
    d: "M7.948,8.751l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a30",
    "data-name": "a",
    d: "M9.6,10.98l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a31",
    "data-name": "a",
    d: "M9.6,10.98l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a32",
    "data-name": "a",
    d: "M9.942,11.229h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a33",
    "data-name": "a",
    d: "M9.942,11.229l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a34",
    "data-name": "a",
    d: "M9.258,11.229l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a35",
    "data-name": "a",
    d: "M9.258,11.229h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a36",
    "data-name": "a",
    d: "M9.812,11.631l-.112-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a37",
    "data-name": "a",
    d: "M9.812,11.631l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a38",
    "data-name": "a",
    d: "M9.388,11.631l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a39",
    "data-name": "a",
    d: "M9.388,11.631l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a40",
    "data-name": "a",
    d: "M9.6,9.54l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a41",
    "data-name": "a",
    d: "M9.6,9.54l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a42",
    "data-name": "a",
    d: "M9.942,9.789h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a43",
    "data-name": "a",
    d: "M9.942,9.789l-.291.211-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a44",
    "data-name": "a",
    d: "M9.258,9.789l.291.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a45",
    "data-name": "a",
    d: "M9.258,9.789h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a46",
    "data-name": "a",
    d: "M9.812,10.191l-.112-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a47",
    "data-name": "a",
    d: "M9.812,10.191l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a48",
    "data-name": "a",
    d: "M9.388,10.191l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a49",
    "data-name": "a",
    d: "M9.388,10.191l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a50",
    "data-name": "a",
    d: "M9.6,8.1l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a51",
    "data-name": "a",
    d: "M9.6,8.1l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a52",
    "data-name": "a",
    d: "M9.942,8.349h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a53",
    "data-name": "a",
    d: "M9.942,8.349l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a54",
    "data-name": "a",
    d: "M9.258,8.349l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a55",
    "data-name": "a",
    d: "M9.258,8.349h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a56",
    "data-name": "a",
    d: "M9.812,8.751l-.112-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a57",
    "data-name": "a",
    d: "M9.812,8.751l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a58",
    "data-name": "a",
    d: "M9.388,8.751l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a59",
    "data-name": "a",
    d: "M9.388,8.751l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a60",
    "data-name": "a",
    d: "M11.04,10.98l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a61",
    "data-name": "a",
    d: "M11.04,10.98l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a62",
    "data-name": "a",
    d: "M11.382,11.229h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a63",
    "data-name": "a",
    d: "M11.382,11.229l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a64",
    "data-name": "a",
    d: "M10.698,11.229l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a65",
    "data-name": "a",
    d: "M10.698,11.229h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a66",
    "data-name": "a",
    d: "M11.252,11.631l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a67",
    "data-name": "a",
    d: "M11.252,11.631l-.291-.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a68",
    "data-name": "a",
    d: "M10.828,11.631l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a69",
    "data-name": "a",
    d: "M10.828,11.631l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a70",
    "data-name": "a",
    d: "M11.04,9.54l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a71",
    "data-name": "a",
    d: "M11.04,9.54l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a72",
    "data-name": "a",
    d: "M11.382,9.789h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a73",
    "data-name": "a",
    d: "M11.382,9.789l-.291.211-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a74",
    "data-name": "a",
    d: "M10.698,9.789l.291.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a75",
    "data-name": "a",
    d: "M10.698,9.789h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a76",
    "data-name": "a",
    d: "M11.252,10.191l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a77",
    "data-name": "a",
    d: "M11.252,10.191l-.291-.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a78",
    "data-name": "a",
    d: "M10.828,10.191l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a79",
    "data-name": "a",
    d: "M10.828,10.191l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a80",
    "data-name": "a",
    d: "M11.04,8.1l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a81",
    "data-name": "a",
    d: "M11.04,8.1l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a82",
    "data-name": "a",
    d: "M11.382,8.349h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a83",
    "data-name": "a",
    d: "M11.382,8.349l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a84",
    "data-name": "a",
    d: "M10.698,8.349l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a85",
    "data-name": "a",
    d: "M10.698,8.349h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a86",
    "data-name": "a",
    d: "M11.252,8.751l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a87",
    "data-name": "a",
    d: "M11.252,8.751l-.291-.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a88",
    "data-name": "a",
    d: "M10.828,8.751l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a89",
    "data-name": "a",
    d: "M10.828,8.751l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a90",
    "data-name": "a",
    d: "M5.28,10.98l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a91",
    "data-name": "a",
    d: "M5.28,10.98l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a92",
    "data-name": "a",
    d: "M5.622,11.229h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a93",
    "data-name": "a",
    d: "M5.622,11.229l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a94",
    "data-name": "a",
    d: "M4.938,11.229l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a95",
    "data-name": "a",
    d: "M4.938,11.229h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a96",
    "data-name": "a",
    d: "M5.492,11.631l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a97",
    "data-name": "a",
    d: "M5.492,11.631l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a98",
    "data-name": "a",
    d: "M5.068,11.631l.291-.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a99",
    "data-name": "a",
    d: "M5.068,11.631l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a100",
    "data-name": "a",
    d: "M6.72,10.98l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a101",
    "data-name": "a",
    d: "M6.72,10.98l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a102",
    "data-name": "a",
    d: "M7.062,11.229h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a103",
    "data-name": "a",
    d: "M7.062,11.229l-.291.212-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a104",
    "data-name": "a",
    d: "M6.378,11.229l.291.212.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a105",
    "data-name": "a",
    d: "M6.378,11.229h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a106",
    "data-name": "a",
    d: "M6.932,11.631l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a107",
    "data-name": "a",
    d: "M6.932,11.631l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a108",
    "data-name": "a",
    d: "M6.508,11.631l.292-.211-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a109",
    "data-name": "a",
    d: "M6.508,11.631l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a110",
    "data-name": "a",
    d: "M6.72,9.54l-.111.342.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a111",
    "data-name": "a",
    d: "M6.72,9.54l.111.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a112",
    "data-name": "a",
    d: "M7.062,9.789h-.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a113",
    "data-name": "a",
    d: "M7.062,9.789l-.291.211-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a114",
    "data-name": "a",
    d: "M6.378,9.789l.291.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a115",
    "data-name": "a",
    d: "M6.378,9.789h.36v.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a116",
    "data-name": "a",
    d: "M6.932,10.191l-.111-.342-.171.056",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a117",
    "data-name": "a",
    d: "M6.932,10.191l-.292-.211.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a118",
    "data-name": "a",
    d: "M6.508,10.191l.292-.211-.106-.146",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "a119",
    "data-name": "a",
    d: "M6.508,10.191l.111-.342.171.056",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUz);
export default __webpack_public_path__ + "static/media/UZ.d06378a4d339f803712ebc6d64c1b1fb.svg";
export { ForwardRef as ReactComponent };